import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

const GoogleAuthSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth(); // ✅ this updates the context

  useEffect(() => {
    const token = searchParams.get('token');
    console.log('Extracted token:', token);
    if (token) {
      localStorage.setItem('token', token); // ✅ Save in localStorage

      // ✅ Update auth context so the app knows you're logged in
      login(token); // <-- very important

      // ✅ Navigate after updating auth context
      navigate('/dashboard');
    } else {
      navigate('/login?error=missing-token');
    }
  }, []);

  return <div>Redirecting...</div>;
};

export default GoogleAuthSuccess;
